import { IComplexDate } from './date-control-formater';

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export function convertToCompatibleDateFormat(date: Date | IComplexDate | undefined | null): IComplexDate | unknown {
  if (date instanceof Date) {
    const month = date.getMonth() + 1;
    const formattedMonth = `${month.toString().length === 1 ? '0' + month : month}`;
    const formattedDay = `${date.getDate().toString().length === 1 ? '0' + date.getDate() : date.getDate()}`;
    const epoc = Math.round(date.getTime() / 1000);

    return {
      date: {
        year: date.getFullYear(),
        month,
        day: date.getDate(),
      },
      jsdate: date,
      formatted: `${date.getFullYear()}/${formattedMonth}/${formattedDay}`,
      epoc,
    };
  } else {
    return date;
  }
}
